export class AppointmentStatus {
    static get APPOINTMENT_CREATED(): string {
        return 'APPOINTMENT_CREATED';
    }
    static get PATIENT_AVAILABILITY_SET(): string {
        return 'PATIENT_AVAILABILITY_SET';
    }
    static get PROVIDER_AVAILABILITY_SET(): string {
        return 'PROVIDER_AVAILABILITY_SET';
    }
    static get PATIENT_SELECTED_APPOINTMENTSLOT(): string {
        return 'PATIENT_SELECTED_APPOINTMENTSLOT';
    }
    static get APPOINTMENT_SCHEDULED(): string {
        return 'APPOINTMENT_SCHEDULED';
    }
    static get APPOINTMENT_CANCELLED(): string {
        return 'APPOINTMENT_CANCELLED';
    }
    static get NEW_APPOINTMENT(): string {
        return 'NEW_APPOINTMENT';
    }
}